export const ACTIVITY_TYPE = {
  MENU_VISITED: "menu_visited",
  SEARCH_ALLERGEN: "search_allergen"
}

// Queued by the outbox, so the moment it happened travels with it.
export function activityRequest(activityType, occurredAt = new Date()) {
  return {
    method: "post",
    url: "/frontline/activity/track/",
    data: { activity_type: activityType, occurred_at: occurredAt.toISOString() }
  }
}
